import { StorageServiceInstance } from "../services/storage";

type TeamScoreboardFlag = { momentScoreboardFanEnabled?: boolean } | undefined;

/**
 * Fan Moment Scoreboard toggle (on-photo overlay, crop toolbar, download baking).
 * Only the home team (team1) Edit Team settings apply; away team (team2) is ignored.
 */
export function isFanMomentScoreboardEnabled(): boolean {
  const g = StorageServiceInstance.selectedGameData;
  if (!g) return true;
  const home = g.team1 as TeamScoreboardFlag;
  return home?.momentScoreboardFanEnabled !== false;
}
